import React, { useState } from "react";
import StudentFeeSummary from "./StudentFeeSummary";
import FeeBreakupSummary from "./FeeBreakupSummary";
import { useFetchPaymentDetails } from "./service";
import {FeeBreakupSummaryForCharges} from './index' 
import ALoader from "../../../common/a-loader";
// ChargesStudentFeeSummary this component is getting rendered from charges page
const ChargesStudentFeeSummary = ({ currentApplicationDetails }) => {


  return (
    <FeeBreakupSummaryForCharges  currentApplicationDetails =  {currentApplicationDetails}/>

  );
};



export default ChargesStudentFeeSummary;
